(function() {
  const STORAGE_KEY = 'pet_name';
  const ENABLED_STORAGE_KEY = 'pet_name_enabled';
  const DEFAULT_ATTRIBUTE_NAME = 'Nombre mascota';

  function getBlock() {
    return document.querySelector('[data-pet-name-block]');
  }

  function getInput() {
    return document.querySelector('[data-pet-name-input]');
  }

  function getToggle() {
    return document.querySelector('[data-pet-name-toggle]');
  }

  function getFields() {
    return document.querySelector('[data-pet-name-fields]');
  }

  function getErrorElement() {
    return document.querySelector('[data-pet-name-error]');
  }

  function cleanValue(value) {
    return String(value || '').trim();
  }

  function getAttributeName() {
    const input = getInput();
    const attributeName = input?.dataset.petNameAttribute?.trim();

    return attributeName || DEFAULT_ATTRIBUTE_NAME;
  }

  function boolFromDataset(value, defaultValue) {
    if (value === undefined || value === null || value === '') return defaultValue;
    return String(value) === 'true';
  }

  function isPersonalizationEnabled() {
    const toggle = getToggle();

    if (!toggle) {
      return Boolean(getInput());
    }

    return Boolean(toggle.checked && !toggle.disabled);
  }

  function isNameRequired() {
    const block = getBlock();
    return boolFromDataset(block?.dataset.petNameRequireName, true);
  }

  function isPersonalizationProductAvailable() {
    const block = getBlock();
    return boolFromDataset(block?.dataset.petNameProductAvailable, false);
  }

  function getPersonalizationVariantId() {
    const block = getBlock();
    const variantId = block?.dataset.petNameProductVariantId;

    if (!variantId) return null;

    const parsedVariantId = parseInt(variantId, 10);
    return Number.isNaN(parsedVariantId) ? null : parsedVariantId;
  }

  function getFeeQuantity(mainQuantity) {
    const block = getBlock();
    const mode = block?.dataset.petNameFeeQuantityMode || 'match_quantity';
    const quantity = Math.max(1, parseInt(mainQuantity, 10) || 1);

    return mode === 'once' ? 1 : quantity;
  }

  function setError(message) {
    const errorElement = getErrorElement();
    const input = getInput();

    if (errorElement) {
      errorElement.textContent = message || '';
      errorElement.hidden = !message;
    }

    if (input) {
      if (message) {
        input.setAttribute('aria-invalid', 'true');
      } else {
        input.removeAttribute('aria-invalid');
      }
    }
  }

  function showFields(show) {
    const fields = getFields();

    if (fields) {
      fields.hidden = !show;
    }
  }

  function getPetName() {
    if (!isPersonalizationEnabled()) return '';

    const input = getInput();
    return cleanValue(input?.value || '');
  }

  function setPetName(value) {
    const clean = cleanValue(value);

    if (clean) {
      localStorage.setItem(STORAGE_KEY, clean);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }

    const input = getInput();

    if (input && input.value !== clean) {
      input.value = clean;
    }

    return clean;
  }

  async function syncPetNameToCart() {
    const attributeName = getAttributeName();
    const petName = getPetName();

    const attributes = {};
    attributes[attributeName] = petName;

    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ attributes })
    });

    if (!response.ok) {
      throw new Error('No se pudo guardar el nombre de la mascota en el carrito');
    }

    const cart = await response.json();

    console.log('[PetNameAttribute] Cart attributes actualizados:', cart.attributes);

    return cart;
  }

  function validatePersonalization() {
    if (!isPersonalizationEnabled()) {
      setError('');
      return '';
    }

    if (!getPersonalizationVariantId()) {
      const message = 'Falta configurar el producto de personalización.';
      setError(message);
      throw new Error(message);
    }

    if (!isPersonalizationProductAvailable()) {
      const message = 'La personalización no está disponible en este momento.';
      setError(message);
      throw new Error(message);
    }

    const petName = getPetName();

    if (isNameRequired() && !petName) {
      const message = 'Ingresa el nombre de tu mascota.';
      setError(message);
      getInput()?.focus();
      throw new Error(message);
    }

    setError('');
    return petName;
  }

  function buildCartItems(mainVariantId, quantity, mainProperties) {
    const parsedMainVariantId = parseInt(mainVariantId, 10);
    const parsedQuantity = Math.max(1, parseInt(quantity, 10) || 1);

    if (!parsedMainVariantId || Number.isNaN(parsedMainVariantId)) {
      throw new Error('No se pudo obtener el ID del producto principal.');
    }

    const petName = validatePersonalization();
    const attributeName = getAttributeName();
    const properties = Object.assign({}, mainProperties || {});

    if (isPersonalizationEnabled()) {
      properties[attributeName] = petName;
      properties._personalizacion_nombre_mascota = 'true';
    }

    const items = [
      {
        id: parsedMainVariantId,
        quantity: parsedQuantity,
        properties: properties
      }
    ];

    if (isPersonalizationEnabled()) {
      items.push({
        id: getPersonalizationVariantId(),
        quantity: getFeeQuantity(parsedQuantity),
        properties: {
          _pet_name_fee: 'true',
          _for_variant_id: String(parsedMainVariantId),
          [attributeName]: petName
        }
      });
    }

    return items;
  }

  function getFormProperties(form) {
    const properties = {};
    const formData = new FormData(form);

    formData.forEach(function(value, key) {
      const match = key.match(/^properties\[(.+)\]$/);

      if (!match) return;
      if (value === '') return;

      properties[match[1]] = value;
    });

    return properties;
  }

  function getFormVariantId(form) {
    const formData = new FormData(form);
    const variantId = formData.get('id');

    return variantId ? parseInt(variantId, 10) : null;
  }

  function getFormQuantity(form) {
    const formData = new FormData(form);
    const quantity = formData.get('quantity');

    return Math.max(1, parseInt(quantity, 10) || 1);
  }

  function getAddToCartUrl() {
    if (window.routes && window.routes.cart_add_url) {
      return window.routes.cart_add_url;
    }

    return '/cart/add.js';
  }

  function getCartElement() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function getSectionsPayload() {
    const cartElement = getCartElement();

    if (cartElement && typeof cartElement.getSectionsToRender === 'function') {
      return {
        sections: cartElement.getSectionsToRender().map(function(section) {
          return section.id;
        }),
        sections_url: window.location.pathname
      };
    }

    return {};
  }

  async function addItemsToCart(items) {
    const body = Object.assign({ items: items }, getSectionsPayload());

    const response = await fetch(getAddToCartUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.description || result.message || 'No se pudo agregar al carrito.');
    }

    return result;
  }

  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js', {
        headers: {
          'Accept': 'application/json'
        }
      });

      if (!response.ok) return;

      const cart = await response.json();
      const countElements = document.querySelectorAll('.cart-count-bubble, [data-cart-count]');

      countElements.forEach(function(element) {
        element.textContent = cart.item_count;
        element.classList.remove('hidden');
      });
    } catch (error) {
      console.error('[PetNameAttribute] Error actualizando contador del carrito:', error);
    }
  }

    function forceCartDrawerFilledState() {
    const cartDrawer = document.querySelector('cart-drawer');

    if (!cartDrawer) return;

    cartDrawer.classList.remove('is-empty');

    const drawerInner = cartDrawer.querySelector('.drawer__inner');
    if (drawerInner) {
      drawerInner.classList.remove('is-empty');
    }

    const cartDrawerItems = cartDrawer.querySelector('cart-drawer-items');
    if (cartDrawerItems) {
      cartDrawerItems.classList.remove('is-empty');
    }

    const scrollArea = cartDrawer.querySelector('.drawer__scroll-area');
    if (scrollArea) {
      scrollArea.hidden = false;
      scrollArea.style.removeProperty('display');
      scrollArea.style.removeProperty('visibility');
      scrollArea.style.removeProperty('opacity');
    }

    const stickyFooter = cartDrawer.querySelector('.drawer__sticky-footer');
    if (stickyFooter) {
      stickyFooter.hidden = false;
      stickyFooter.style.removeProperty('display');
      stickyFooter.style.removeProperty('visibility');
      stickyFooter.style.removeProperty('opacity');
    }

    const warnings = cartDrawer.querySelector('.cart-drawer__warnings');
    if (warnings) {
      warnings.hidden = true;
    }
  }

  function openCartDrawerSafely() {
    const cartDrawer = document.querySelector('cart-drawer');

    if (!cartDrawer) return;

    forceCartDrawerFilledState();

    if (typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      return;
    }

    cartDrawer.classList.add('active');
    document.body.classList.add('overflow-hidden');
  }

  function renderCart(result) {
    const cartElement = getCartElement();

    forceCartDrawerFilledState();

    if (cartElement && typeof cartElement.renderContents === 'function') {
      cartElement.renderContents(result);

      requestAnimationFrame(function() {
        forceCartDrawerFilledState();
        openCartDrawerSafely();
      });

      setTimeout(function() {
        forceCartDrawerFilledState();
        openCartDrawerSafely();
      }, 100);

      return;
    }

    updateCartCount();

    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: result }));
    window.dispatchEvent(new CustomEvent('cart:refresh', { detail: result }));

    requestAnimationFrame(function() {
      forceCartDrawerFilledState();
      openCartDrawerSafely();
    });
  }

  function publishCartUpdate(result, variantId) {
    try {
      if (window.PUB_SUB_EVENTS && window.publish) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
          source: 'pet-name-personalization',
          productVariantId: variantId,
          cartData: result
        });
      }
    } catch (error) {
      console.error('[PetNameAttribute] Error publicando cartUpdate:', error);
    }
  }

  function setSubmitButtonLoading(form, isLoading, errorMessage) {
    const button = form.querySelector('[type="submit"], button[name="add"], .product-form__submit');

    if (!button) return;

    if (!button.dataset.originalText) {
      button.dataset.originalText = button.textContent.trim();
    }

    button.disabled = isLoading;

    if (isLoading) {
      button.textContent = 'Adding...';
      return;
    }

    if (errorMessage) {
      button.textContent = 'Error';

      setTimeout(function() {
        button.textContent = button.dataset.originalText || 'Add to cart';
        button.disabled = false;
      }, 1800);

      return;
    }

    button.textContent = button.dataset.originalText || button.textContent;
  }

  function submitFormNormallyAfterSync(form) {
    form.dataset.petNameBypass = 'true';

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }

    setTimeout(function() {
      delete form.dataset.petNameBypass;
    }, 1000);
  }

  function interceptMainProductForms() {
    document.addEventListener('submit', async function(event) {
      const form = event.target.closest('form[action*="/cart/add"]');

      if (!form) return;
      if (!getBlock()) return;
      if (form.dataset.petNameBypass === 'true') return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (!isPersonalizationEnabled()) {
        try {
          await syncPetNameToCart();
        } catch (error) {
          console.error('[PetNameAttribute] Error limpiando/sincronizando antes de add-to-cart:', error);
        }

        submitFormNormallyAfterSync(form);
        return;
      }

      const variantId = getFormVariantId(form);
      const quantity = getFormQuantity(form);
      const properties = getFormProperties(form);

      try {
        setSubmitButtonLoading(form, true);

        const items = buildCartItems(variantId, quantity, properties);

        await syncPetNameToCart();

        const result = await addItemsToCart(items);

        renderCart(result);
        publishCartUpdate(result, variantId);
        setSubmitButtonLoading(form, false);
      } catch (error) {
        console.error('[PetNameAttribute] Error agregando producto personalizado:', error);

        setError(error.message || 'No se pudo agregar la personalización.');
        setSubmitButtonLoading(form, false, error.message);
      }
    }, true);
  }

  function interceptCheckoutButtons() {
    document.addEventListener('click', async function(event) {
      const checkoutButton = event.target.closest(
        'button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href*="/checkout"]'
      );

      if (!checkoutButton) return;
      if (!getBlock()) return;
      if (checkoutButton.dataset.petNameSynced === 'true') return;

      event.preventDefault();
      event.stopImmediatePropagation();

      try {
        await syncPetNameToCart();

        checkoutButton.dataset.petNameSynced = 'true';
        checkoutButton.click();

        setTimeout(function() {
          delete checkoutButton.dataset.petNameSynced;
        }, 1000);
      } catch (error) {
        console.error('[PetNameAttribute] Error sincronizando antes de checkout:', error);

        delete checkoutButton.dataset.petNameSynced;
        checkoutButton.click();
      }
    }, true);
  }

  function initPetNameBlock() {
    const block = getBlock();
    const input = getInput();
    const toggle = getToggle();

    if (!block || !input || input.dataset.petNameInitialized === 'true') return;

    input.dataset.petNameInitialized = 'true';

    const savedValue = localStorage.getItem(STORAGE_KEY) || '';
    const wasEnabled = localStorage.getItem(ENABLED_STORAGE_KEY) === 'true';
    const shouldEnable = Boolean(toggle && !toggle.disabled && (wasEnabled || savedValue));

    if (toggle) {
      toggle.checked = shouldEnable;
    }

    showFields(shouldEnable || !toggle);

    if (savedValue && shouldEnable) {
      input.value = savedValue;
      syncPetNameToCart().catch(console.error);
    }

    let timeout;

    if (toggle) {
      toggle.addEventListener('change', function(event) {
        const enabled = Boolean(event.target.checked);

        localStorage.setItem(ENABLED_STORAGE_KEY, enabled ? 'true' : 'false');
        showFields(enabled);
        setError('');

        if (!enabled) {
          setPetName('');
        } else {
          input.focus();
        }

        syncPetNameToCart().catch(console.error);
      });
    }

    input.addEventListener('input', function(event) {
      setPetName(event.target.value);
      setError('');

      clearTimeout(timeout);

      timeout = setTimeout(function() {
        syncPetNameToCart().catch(console.error);
      }, 400);
    });

    input.addEventListener('change', function(event) {
      setPetName(event.target.value);
      syncPetNameToCart().catch(console.error);
    });

    input.addEventListener('blur', function(event) {
      setPetName(event.target.value);
      syncPetNameToCart().catch(console.error);
    });
  }

  window.PetNameAttribute = {
    get: getPetName,
    set: setPetName,
    sync: syncPetNameToCart,
    enabled: isPersonalizationEnabled,
    buildCartItems: buildCartItems,
    validate: validatePersonalization
  };

  document.addEventListener('DOMContentLoaded', function() {
    initPetNameBlock();
    interceptMainProductForms();
    interceptCheckoutButtons();
  });

  document.addEventListener('shopify:section:load', function() {
    initPetNameBlock();
  });
})();